<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="" v-else-if="loaded" >
        <ul class="horizontal-menu font-size-16" >
            <li>
                <router-link :to="{name: 'Leads'}" > Leads </router-link>
            </li>
            <li>
                <router-link :to="{name: 'LeadConversions'}"  > Conversions </router-link>
            </li>
            
        </ul>
        
        <div class="" > 
            <router-view></router-view>
        </div>
    </div>

</template>

<script>

    import Cookies from 'js-cookie'

export default {
    name: 'Customers',
    props: {
        
        
    },
    data: function(){
        return {
            pagetitle: "Customers",
            loaded: false
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted() {
        //console.log( this.$route )
        this.loaded = true;
    },
    beforeDestroy() {
    },
    methods: {

    },
    computed: {

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>



// WEBPACK FOOTER //
// src/templates/leads/Leads_main.vue